<template>
    <section class="content">
        <div class="container-fluid">
        	<div class="row">
        		<!-- <filterForm></filterForm> -->
        	</div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-header" style="text-align: left;">
		                    <h5>Collections Chart</h5>
		                    <span id="pp_start_date">{{ indexData.pp_start_date }}</span>
		                    <span id="pp_end_date">{{ indexData.pp_end_date }}</span>
		                </div>
                        <div class="card-block" style="padding: 1.25rem;">
                            <!-- Row start -->
                            <div class="" >
                                <canvas id="chart-container" height="80">
                                    Charts will render here
                                </canvas>
                            </div>
                            <!-- Row end -->
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    </section>
</template>

<script>
    import Chart from 'chart.js/auto';
    import { getRelativePosition } from 'chart.js/helpers';
    import ChartDataLabels from 'chartjs-plugin-datalabels';

    export default {
        data () {
            return {
            	indexData: {},
             	adsCahrt: {},
            }
        },
        methods: {
        	getIndex() {
        		axios.get("api/v1/collections").then(({ data }) => {this.indexData = data.data;
        			this.getAds();
        		});
        	},
            getAds() {

                Chart.register(ChartDataLabels);

                const ctx = document.getElementById('chart-container');

                axios.post("api/v1/getDashboard", this.indexData).then(({ data }) => { 
                const chart = new Chart(ctx, {
                    type: 'bar',
                    responsive: true,
		            data: {
			            labels: data.data.users,
			            datasets: [
			            	{
		                        label: "Case Count",
		                        yAxisID: 'caseAxis',
		                        opposite: false,
		                        backgroundColor: "#3e95cd",
		                        data: data.data.case_count,
	                    	},
	                    	{
		                        label: "Total $",
		                        yAxisID: 'usdAxis',
		                        opposite: false,
		                        backgroundColor: "#3cba9f",
		                        data: data.data.total_usd,
	                    	}
	                	]
		            },
		            options: {
		                scales: {
		                	caseAxis: {
		                		position: 'left',
		                		type: 'linear',
		                		beginAtZero: true,
		                		title: {
		                            display: true,
		                            // text: 'Predicted world population (millions) in 2050'
		                        }
		                	},
		                	usdAxis: {
		                		position: 'right',
		                		type: 'linear',
		                		beginAtZero: true,
		                	},
		                },
		                plugins: {
		                    datalabels: {
		                        formatter: Math.round,
		                        font: {
		                            weight: 'bold'
		                        },
		                        color: "#ffffff"
		                    }
		                },
		                legend: {
		                    display: true,
		                    labels: {
		                        fontStyle: 'bold'
		                    }
		                }
		            },
                });
                }).catch((data)=> {
                    Swal.fire("Failed!", data.message, "warning");
                });
            },
        },
        mounted() {
           	console.log('Component mounted.')
            // this.getAds();
            this.getIndex();
        },
        created() {
        }
    }
</script>